/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IconUpload, IconX } from "@tabler/icons-react";
import SelectInput from "../../../components/Select";
import {
  Control,
  RegisterOptions,
  useForm,
  UseFormClearErrors,
  UseFormRegisterReturn,
} from "react-hook-form";
import Input from "../../../components/Input";
import ToggleButton from "../../../components/ToggleButton";
import FileUploader from "../../../components/common/FileUploader";
import Radio from "../../../components/common/Radio";
import CoverageCities from "./CoverageCities";
import InputField from "../../../components/common/InputField";
import {
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
  useFetchCountryWarehouseAllData,
} from "../../../apis/locationApis";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
type Props = {
  onClose: () => void;
  handleSubmit: () => void;
  selectedWarehouse: string;
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  coverageCityError: any;
  setCoverageCityError: any;
  isPending?: boolean;
  editable?: boolean;
  tireItem?: any;
  setTireItem?: any;
};

export default function AddTireModal({
  onClose,
  handleSubmit,
  selectedWarehouse,
  register,
  errors,
  setValue,
  watch,
  control,
  clearErrors,
  coverageCityError,
  setCoverageCityError,
  isPending,
  editable,
  tireItem = {},
  setTireItem,
}: Props) {
  const { data: warehouseData, refetch: fetchWarehouses } =
    useFetchCountryWarehouseAllData();
  const { data: countriesData } = useFetchCountriesAllData();

  const [selectedCitiesArray, setSelectedCitiesArray] = useState<any>();

  const [cities, setCities] = useState<any>([]);
  const [checked, setChecked] = useState<boolean>(false);

  const { data: citiesData, refetch: countryRefetch } =
    useFetchCountryCitiesAllData(watch("countryId"));

  useEffect(() => {
    setCities(citiesData);
  }, [citiesData]);

  useEffect(() => {
    if (selectedCitiesArray) {
      setValue("coverageCity", selectedCitiesArray);
    }
  }, [selectedCitiesArray]);

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
        <div className="rounded-2xl h-full w-6/12 relative">
          <div className="flex items-center">
            <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
              <h1 className="text-2xl">Create Tire</h1>
            </div>
            <div className="relative ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={38}
                height={37}
                viewBox="0 0 38 37"
                fill="none"
                className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
              >
                <path
                  d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                  fill="#F7F6F2"
                />
              </svg>

              <button
                onClick={() => {
                  setTireItem(null);
                  onClose();
                }}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
              >
                <IconX size={20} />
              </button>
            </div>
          </div>
          <div className="w-full py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]  ">
            <div className=" h-[calc(100vh-13rem)] overflow-y-auto space-y-4">
              <div className="grid grid-cols-3 gap-4">
                <p className="text-[#212121]/80 col-span-3 uppercase text-sm font-medium">
                  Select Information
                </p>{" "}
                <NewinputField
                  name="name"
                  type="text"
                  title="Tire Name"
                  placeholder="Enter Tire Name"
                  register={register}
                  error={errors.name}
                  validation={{ required: "Tire Name is required" }}
                />
                <NewSelectInput
                  label="Select warehouse"
                  selectOptions={
                    warehouseData?.warehouses?.map((warehouse: any) => ({
                      id: warehouse.id,
                      value: warehouse.id,
                      text: warehouse.name,
                    })) || []
                  }
                  name="warehouseId"
                  clearErrors={clearErrors}
                  register={register}
                  validation={{ required: "Warehouse is required" }}
                  value={watch("warehouseId")}
                  setValue={(val: string) => {
                    setValue("warehouseId", val);
                  }}
                  disabled={!warehouseData || warehouseData?.warehouses?.length === 0}
                  error={errors.warehouseId}
                />
                <NewSelectInput
                  label="Select country"
                  selectOptions={
                    countriesData?.map((country: any) => ({
                      id: country?.id,
                      value: country?.id,
                      text: country?.name,
                    })) || []
                  }
                  name="countryId"
                  clearErrors={clearErrors}
                  validation={{ required: "Country is required" }}
                  register={register}
                  disabled={!countriesData || countriesData.length === 0}
                  value={watch("countryId")}
                  setValue={(val: string) => {
                    setValue("countryId", val);
                  }}
                  error={errors.countryId}
                />
              </div>
              {!editable && (
                <div className="flex justify-between items-center">
                  <h2 className="text-[#000000]/70 text-base">
                    Choose Bulk Upload
                  </h2>
                  <div className="flex items-center gap-1">
                    <ToggleButton
                      onChange={() => setChecked(!checked)}
                      checked={checked}
                    />
                    <h2 className="text-[#000000]/70 text-base">Bulk Upload</h2>
                  </div>
                </div>
              )}
              {checked ? (
                <>
                  <FileUploader
                    name="document"
                    classNameMain="bg-white outline-2 outline-dashed outline-[#212121]/10"
                    title="Upload Your File"
                    message="Accepted formats: .xls, .xlsx, .csv | Max: 5MB"
                    placeHolder=""
                    img="/img/upload-img.png"
                    classNameImgDiv=" flex flex-col items-center justify-center"
                  />
                  <ul className="list-disc px-6 text-[#1E293B] text-sm">
                    <li>Download the Excel/CSV template before uploading. </li>
                    <li>Do not change column headers.</li>
                  </ul>
                  <div className="bg-[#ffffff] flex justify-between items-center px-4 py-2 rounded col-span-2">
                    <p className="text-xs w-full">
                      <b className="text-[#EC221F]">Note</b>: Please upload the
                      file in the same format as the downloaded file
                    </p>
                    <div className="w-full flex justify-end items-end">
                      <button className="bg-[#000000] text-white px-4 py-2 rounded flex items-center gap-1 text-xs">
                        <img src="/img/csvxl.svg" alt="" /> Download
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                // citiesData?.length > 0 && (
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-[#FCFDF8] p-2 rounded-lg col-span-2">
                    <CoverageCities
                      ALL_CITIES={citiesData}
                      selectedCityData={[]}
                      setSelectedCitiesArray={setSelectedCitiesArray}
                      error={coverageCityError}
                      setError={setCoverageCityError}
                      isEdit={false}
                    />
                  </div>
                </div>
                // )
              )}
            </div>
          </div>
          <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] ">
            <button
              onClick={() => {
                handleSubmit();
              }}
              className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
            >
              {isPending && (
                <svg
                  className="animate-spin h-5 w-5 text-white mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                  />
                </svg>
              )}
              Create
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
